import { render } from "./ComponentDetailWiki.vue?vue&type=template&id=a5fd234c&scoped=true"
import script from "./ComponentDetailWiki.vue?vue&type=script&lang=js"
export * from "./ComponentDetailWiki.vue?vue&type=script&lang=js"

import "./ComponentDetailWiki.vue?vue&type=style&index=0&id=a5fd234c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fd234c"]])

export default __exports__